import { render, staticRenderFns } from "./BaseHistory.vue?vue&type=template&id=d14bfa66"
import script from "./BaseHistory.vue?vue&type=script&lang=js"
export * from "./BaseHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports